import React from 'react';

const ExamResultsPage = ({ page, examResult }) => {
  const config = page.resultsConfig || {};
  const { score, passed, totalQuestions, correctAnswers, message, progressReset, certificate } = examResult || {};

  const getMessage = () => {
    if (message) return message;
    if (passed && config.messages?.passed) {
      return config.messages.passed.replace('{score}', score);
    }
    if (!passed && config.messages?.failed) {
      return config.messages.failed.replace('{score}', score);
    }
    return '';
  };

  return (
    <div>
     
      {page.title && (
        <h1 className="text-3xl font-bold mb-6 text-gray-800">{page.title}</h1>
      )}

      {page.blocks && page.blocks.map((block) => {
        if (block.type === 'sub-header') {
          return (
            <h2
              key={block.id}
              className={`text-${block.style?.fontSize || '2xl'} font-${block.style?.fontWeight || 'bold'} text-${block.style?.color || 'gray-800'} mb-4`}
            >
              {block.text}
            </h2>
          );
        }
        return null;
      })}

      {config.showScore && score !== undefined && (
        <div className={`mb-6 p-6 rounded-lg ${passed ? 'bg-green-50 border-2 border-green-500' : 'bg-red-50 border-2 border-red-500'}`}>
          <div className="text-center">
            <div className={`text-4xl font-bold mb-2 ${passed ? 'text-green-700' : 'text-red-700'}`}>
              {score}%
            </div>
            {config.showTotalQuestions && totalQuestions !== undefined && (
              <div className="text-gray-600">
                {correctAnswers || 0} out of {totalQuestions} questions correct
              </div>
            )}
          </div>
        </div>
      )}

      {config.showPassed && passed !== undefined && (
        <div className={`mb-6 p-4 rounded-lg text-center ${passed ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          <div className="text-xl font-semibold">
            {passed ? '✓ Passed' : '✗ Failed'}
          </div>
        </div>
      )}

      {getMessage() && (
        <div className={`mb-6 p-4 rounded-lg ${passed ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>
          <p>{getMessage()}</p>
        </div>
      )}

      
      {certificate && (
        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-blue-800">
            <strong>Certificate Number:</strong> {certificate.certificateNumber}
          </p>
          <p className="text-blue-800 text-sm mt-1">
            Issued: {new Date(certificate.issuedAt).toLocaleDateString()}
          </p>
        </div>
      )}

      
      {progressReset && (
        <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-yellow-800">
            All lesson progress has been reset. Please retake the lessons to attempt the exam again.
          </p>
        </div>
      )}
    </div>
  );
};

export default ExamResultsPage;

